import { render, staticRenderFns } from "./PageTwoView.vue?vue&type=template&id=af2e30c6"
import script from "./PageTwoView.vue?vue&type=script&lang=js"
export * from "./PageTwoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports